import React from 'react';
import PropTypes from 'prop-types';
import { IconButton } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { MoreVert } from '@mui/icons-material';

const useStyles = makeStyles(() => ({
  root: {
    padding: 8,
    '@media (max-width:768px)': {
      padding: 5,
    },
  },
}));

const ButtonMore = ({ onClick }) => {
  const classes = useStyles();
  return (
    <IconButton classes={classes} onClick={onClick}>
      <MoreVert fontSize="small" />
    </IconButton>
  );
};

ButtonMore.propTypes = {
  onClick: PropTypes.func,
};

export default ButtonMore;
